import styled, { css } from 'styled-components';
import { iconButtonStyle, labelStyle } from 'styles/base-classes';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import ExportSVG from 'icons/export.svg';
import EditSVG from 'icons/edit.svg';

export const Label = styled.label`
  ${labelStyle};
`;

export const iconStyle = css`
  transition: all 150ms ease-out;
  stroke: ${({ theme }) => theme.base.PastelBlue};
`;

export const ExportIcon = styled(ExportSVG)`
  ${iconStyle};
`;

export const EditIcon = styled(EditSVG)`
  ${iconStyle};
`;

export const ExportButton = styled(Button)`
  && {
    ${iconButtonStyle};
    border-radius: 3px 0 0 3px;
  }
`;

const activeStyle = css`
  background: ${({ editModeEnabled, theme }) =>
    editModeEnabled ? theme.base.Blue : 'white'};

  svg {
    stroke: ${({ editModeEnabled, theme }) =>
      editModeEnabled ? 'white' : theme.base.PastelBlue};
  }
`;

export const EditButton = styled(Button)`
  && {
    ${iconButtonStyle};
    border-left: none;
    border-radius: 0 3px 3px 0;
    ${({ editModeEnabled }) => editModeEnabled && activeStyle};
  }
`;

export const StyledSwitch = styled(Switch)`
  && {
    position: relative;
    z-index: 0;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  height: 2.625em;
`;



// WEBPACK FOOTER //
// ./src/components/ButtonGroup/ButtonGroup.style.js